//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: ['value', 'disable', 'label', 'multiple', 'numeric-values'],
  data: function data() {
    return {
      model: this.value,
      options: [{
        value: this.numericValues ? 0 : '0',
        label: this.$t('days.sunday')
      }, {
        value: this.numericValues ? 1 : '1',
        label: this.$t('days.monday')
      }, {
        value: this.numericValues ? 2 : '2',
        label: this.$t('days.tuesday')
      }, {
        value: this.numericValues ? 3 : '3',
        label: this.$t('days.wednesday')
      }, {
        value: this.numericValues ? 4 : '4',
        label: this.$t('days.thursday')
      }, {
        value: this.numericValues ? 5 : '5',
        label: this.$t('days.friday')
      }, {
        value: this.numericValues ? 6 : '6',
        label: this.$t('days.saturday')
      }]
    };
  }
};